import { Provider } from '@angular/core'
import { DefenderDeclarationService } from 'game-services'
import { GamePlayConfig } from 'shared-services'
import { gamePlayConfigToken } from 'shared-components'

export const defenderDeclarationServiceProvider: Provider = {
  provide: DefenderDeclarationService,
  useFactory: (gamePlayConfig: GamePlayConfig): DefenderDeclarationService => {
    return new DefenderDeclarationService(gamePlayConfig)
  },
  deps: [gamePlayConfigToken],
}
